import React from 'react';
import { withRouter } from 'react-router-dom';
import { Flex, Heading, Icon } from 'core/components';
import FavoriteButton from 'app/views/core/FavoriteButton';

export const FavoritePosition = {
  Left: 'left',
  Right: 'right'
};

const PageHeading = (props) => {
  const {
    match,
    favoriteId,
    hideFavorite = false,
    favoriteMetadata,
    favoritePosition = FavoritePosition.Left,
    level,
    title,
    titleComponent,
    icon,
    iconComponent,
    ...rest
  } = props;
  const favId = favoriteId || match.url;

  return (
    <Flex gap="4px">
      {!hideFavorite && favoritePosition === FavoritePosition.Left && (
        <FavoriteButton type="page" id={favId} name={title} metadata={favoriteMetadata} />
      )}

      <Heading level={level} fontWeight={500} {...rest} role="heading">
        <Flex alignItems="center" gap={1}>
          {icon && <Icon icon={icon} color="warning" iconSize={24} />}
          {iconComponent}
          {titleComponent || title}
        </Flex>
      </Heading>

      {!hideFavorite && favoritePosition === FavoritePosition.Right && (
        <FavoriteButton type="page" id={favId} name={title} metadata={favoriteMetadata} />
      )}
    </Flex>
  );
};

PageHeading.defaultProps = {
  level: 1
};

/** @type {import('react').ComponentType<any>} */
const RoutedPageHeading = withRouter(PageHeading);

export default RoutedPageHeading;
